/**
 * @ngdoc service
 * @name cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
 * @restrict E
 * @scope
 * @description Servizio che gestisce il processo di creazione nuova pratica e
 *              visualizzazione pratica esistente
 */
(function() {
  angular
    .module('cbl.insuranceloanpmi.mf')
    .service('CreasDettaglioPraticaSrvc', [
      '$http',
      '$q',
      'CreasMessaggiFctr',
      'CONSTANTS',
      'LabelSrvc',
      function($http, $q, messaggiFctr, CONSTANTS, labelSrvc) {
        this.$http = $http;
        this.messaggiFctr = messaggiFctr;
        this.labelSrvc = labelSrvc;

        // Variabili generali pratica
        this.datiPratica = null;
        this.datiCliente = null;
        this.datiClienteBanca = null;
        this.datiClienteCerved = null;
        this.firmatariCliente = [];

        this.idPratica = null;
        this.affidamento = {};

        // Step 2 - Sottostep 1
        this.firmatario = null;
        this.fasciaAffidamento = null;

        // Step 3 - Sottostep 1
        this.firmatarioVerifica = null;

        // Step 4
        this.ibanAddebito = null;

        // Step 6 - Sottostep 1
        this.convenzione = null;

        // Step 6 - Sottostep 2 e 3
        this.titoliAggiunti = [];
        this.finanziamento = null;

        this.isCancelEnabled = null;
        this.isCancelFinanziamentoEnabled = null;
        this.isSaveEnabled = null;
        this.isPrevEnabled = null;
        this.isNextEnabled = null;
        this.isCompleteEnabled = null;
        this.nextStep = null;
        this.salva = null;
        this.completed = null;

        var self = this;

        // Spinner
        this.spinner = {
          pratica: false
        };
        /**
		 * @ngdoc method
		 * @name isClienteCerved
		 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
		 * @description Indica se l'anagrafica del cliente della pratica in
		 *              lavorazione proviene da Cerved
		 * @return {boolean} - True se i dati del cliente provengono da Cerved,
		 *         False se provengono dal DB Banca
		 */
        this.isClienteCerved = function() {
           return self.datiPratica.infoCerved.richiestaAnagrafica;
        };

        /**
		 * @ngdoc method
		 * @name getDatiCliente
		 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
		 * @description Restituisce i dati del cliente con una struttura
		 *              standard, valorizzata a seconda del tipo di dato
		 *              ottenuto (DB Banca o Cerved)
		 * @return {Object} - I dati del cliente assegnato alla pratica
		 */
        this.getDatiCliente = function() {
          if (self.datiCliente) {
            return self.datiCliente;
          }

          // Dati cliente banca
          if (self.datiClienteBanca) {
            return {
              idAnagrafica: self.datiClienteBanca.ndg,
              intestazione: self.datiClienteBanca.intestazione,
              indirizzoPrincipale: self.datiClienteBanca.indirizzoPrincipale,
              codiceFiscale: self.datiClienteBanca.codiceFiscale,
              cciaa: '',
              naturaGiuridica: self.datiClienteBanca.naturaGiuridica,
              situazione: '',
              attivitaEconomica: '',
              ateco: '',
              datacost: self.datiClienteBanca.dataNascita
            };
          }

          // Dati Cerved
          if (self.datiClienteCerved) {
            return {
              idAnagrafica: null,
              intestazione: self.datiClienteCerved.intestazione,
              indirizzoPrincipale: self.datiClienteCerved.indirizzoPrincipale,
              codiceFiscale: self.datiClienteCerved.codiceFiscale,
              cciaa: self.datiClienteCerved.numeroCciaaRea,
              naturaGiuridica: self.datiClienteCerved.formaCostitutiva,
              situazione: null, // self.datiClienteCerved.statoImpresa,
              attivitaEconomica:
                self.datiClienteCerved.settoreAttivitaEconomica,
              ateco: self.datiClienteCerved.ateco,
              datacost: self.datiClienteCerved.dataNascita
            };
          }

          return null;
        };
        
        /**
		 * @ngdoc method
		 * @name getFinanziamentoBozza
		 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
		 * @description Restituisce il finanziamento in stato bozza per la pratica attiva
		 * @return {Object} - L'oggetto finanziamento in stato bozza presente nella pratica
		 */
        this.getFinanziamentoBozza = function() {

        	if (self.datiPratica.elencoFinanziamentoMultiPolizzaPMI) {
        		for (var i=0; i<self.datiPratica.elencoFinanziamentoMultiPolizzaPMI.length; i++) {
        			if (self.datiPratica.elencoFinanziamentoMultiPolizzaPMI[i].stato === 'BOZZA') {
        				return self.datiPratica.elencoFinanziamentoMultiPolizzaPMI[i];
        			}
        		}
        	}
    		
    		return null;
        }
        
        /**
    	 * @ngdoc method
    	 * @name promiseDatiPratica
    	 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
    	 * @description Effettua una chiamata http per ricevere i dati della pratica
    	 * @param {number}
    	 *            idPratica - ID Della pratica della quale recuperare i dati
    	 * @return {Promise} - Ritorna una promise contenente i dati della pratica
    	 */
        this.promiseDatiPratica = function(idPratica) {
          return this.$http({
            method: 'GET',
            url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICHE.DETTAGLIO + idPratica
          });
        };
       

        /**
		 * @ngdoc method
		 * @name promiseFirmatariCliente
		 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
		 * @description Esegue la chiamata per ottenere i firmatari per il
		 *              cliente indicato
		 * @return {Promise} - Restituisce una promise contenente l'elenco dei
		 *         firmatari per il cliente
		 */
        this.promiseFirmatariCliente = function() {
          return this.$http({
            method: 'GET',
            url:
              CONSTANTS.REST_ROOT +
              CONSTANTS.REST.CLIENTI.DETTAGLIO +
              self.datiPratica.idPratica +
              '/firmatari'
          });
        };
        
        /**
		 * @ngdoc method
		 * @name promiseFirmatariVerificati
		 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
		 * @description Esegue la chiamata per ottenere i firmatari verificati per la pratica indicata
		 * @return {Promise} - Restituisce una promise contenente l'elenco dei firmatari verificati
		 */
        this.promiseFirmatariVerificati = function() {
          return this.$http({
            method: 'GET',
            url:
              CONSTANTS.REST_ROOT +
              CONSTANTS.REST.CLIENTI.DETTAGLIO +
              self.datiPratica.idPratica +
              '/firmatariVerificati'
          });
        };
        
        /**
		 * @ngdoc method
		 * @name promiseFirmatarioPratica
		 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
		 * @description Esegue la chiamata per ottenere il firmatario della pratica
		 * @return {Promise} - Restituisce una promise contenente il firmatario della pratica
		 */
        this.promiseFirmatarioPratica = function() {
		  var queryParamsObj = {
	        idPratica: self.datiPratica.idPratica,
	        firmatario: true
	      };
        	
          return this.$http({
            method: 'GET',
            url: CONSTANTS.REST_ROOT + CONSTANTS.REST.CLIENTI.DETTAGLIO_CERCA,
            params: queryParamsObj
          });
        };

        /**
		 * @ngdoc method
		 * @name getFirmatarioPratica
		 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
		 * @description Restituisce il firmatario per la pratica
		 * @return {Object} - I dati del firmatario assegnato alla pratica
		 */
        this.getFirmatarioPratica = function() {
          // Firmatario modificato in fase di verifica
          if (self.firmatarioVerifica) {
            return self.firmatarioVerifica;
          }

          // Firmatario originale
          return self.firmatario;
        };

        /**
		 * @ngdoc method
		 * @name reset
		 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
		 * @description Ripristina a vuoti tutti i dati della pratica in
		 *              lavorazione
		 */
        this.reset = function() {
          self.datiPratica = null;
          self.datiClienteBanca = null;
          self.datiClienteCerved = null;
          self.firmatariCliente = [];

          self.idPratica = null;
          self.affidamento = {};

          self.firmatario = null;
          self.fasciaAffidamento = null;

          self.firmatarioVerifica = null;

          self.ibanAddebito = null;

          self.convenzione = null;

          self.titoliAggiunti = [];
          self.finanziamento = null;

          self.isCancelVisible = null;
          self.isCancelEnabled = null;
          self.isCancelFinanziamentoVisible = null;
          self.isCancelFinanziamentoEnabled = null;
          self.isSaveEnabled = null;
          self.isPrevEnabled = null;
          self.isNextEnabled = null;
          self.isCompleteEnabled = null;
          self.nextStep = null;
          self.salva = null;
          self.completed = null;
        };
        
        /**
		 * @ngdoc method
		 * @name verificaImportiPolizze
		 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
		 * @description Esegue il controllo di verifica degli importi delle polizze aggiunte alla pratica
		 * @param {number} importoNuovaPolizza - Facoltativo, importo della polizza che si sta aggiungendo
		 * @return {Boolean} - Restituisce true se la somma delle polizze aggiunte rispetta i criteri per il salvataggio, false se vi sono state eccezioni
		 */
        this.verificaImportiPolizze = function(importoNuovaPolizza) {
        	var sommaPolizze = self.calcolaImportoPolizze(importoNuovaPolizza);
			
			if (
				self.datiPratica.elencoFinanziamentoMultiPolizzaPMI && self.datiPratica.elencoFinanziamentoMultiPolizzaPMI.length === 1
				&& sommaPolizze < 1000
			) {
				self.messaggiFctr.addMessage({ type: 'W', message: self.labelSrvc.getLabel('label.dettagliopratica.step6.sub3.importominimo') });
				return;
			}
			
			//Se il fido è in stato diverso da "DA_EROGARE" verifico importo disponibile, altrimenti l'importo massimo della fascia fido
			if ((self.datiPratica.fidoNonOperativo.stato !== 'DA_EROGARE' && sommaPolizze > self.datiPratica.fidoNonOperativo.importoDisponibile) || 
					(self.datiPratica.fidoNonOperativo.stato === 'DA_EROGARE' && sommaPolizze > self.datiPratica.fidoNonOperativo.fasciaFido.importoMassimo )) {
				self.messaggiFctr.addMessage({ type: 'W', message: self.labelSrvc.getLabel('label.dettagliopratica.step6.sub3.superatadisponibilita') });
				return;
			}
        	
        	return true;
        }
        
        /**
		 * @ngdoc method
		 * @name calcolaImportoPolizze
		 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
		 * @description Restituisce la somma delle polizze selezionate
		 * @param {number} importoNuovaPolizza - Facoltativo, importo della polizza che si sta aggiungendo
		 * @return {number} - La somma delle polizze selezionate
		 */
        this.calcolaImportoPolizze = function(importoNuovaPolizza) {
        	var sommaPolizze = 0;
        	
        	if (importoNuovaPolizza && importoNuovaPolizza > 0) {
        		sommaPolizze = importoNuovaPolizza;
        	}
        	
        	if (self.finanziamento && self.finanziamento.elencoPolizze) {        		
        		for(var i=0; i < self.finanziamento.elencoPolizze.length; i++) {
        			sommaPolizze = sommaPolizze + self.finanziamento.elencoPolizze[i].importoPremio;
        		}
        	}
        	
        	return sommaPolizze;
        }
        
        /**
    	 * @ngdoc method
    	 * @name isPraticaNavigabile
    	 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
    	 * @description Verifica se la pratica è in stato AFFIDATA, e quindi navigabile
    	 * @return {Boolean} - True se la pratica è navigabile, false in caso contrario
    	 */
        this.isPraticaNavigabile = function() {
          if (!self.datiPratica) {
        	  return false;
          }
          
          return self.datiPratica.stato && (self.datiPratica.stato === 'AFFIDATA' || self.datiPratica.stato === 'CONCLUSA');
        };

        /**
		 * @ngdoc method
		 * @name salvaFido
		 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
		 * @description Esegue la chiamata per salvare la richiesta fido
	     * @param {string} pathstring - Facoltativo, stringa da aggiungere al path per invocare il servizio
		 * @return {Promise} - Restituisce una promise contenente la pratica aggiornata
		 */
        this.promiseSalvaFido = function(pathString) {
          var path = '';
          if (pathString) {
            path = pathString;
          }
          return this.$http({
            method: 'PUT',
            url:
              CONSTANTS.REST_ROOT +
              CONSTANTS.REST.AFFIDAMENTI.FIDO +
              this.datiPratica.fidoNonOperativo.idFidoNonOperativoPMI +
              path,
            data: this.datiPratica
          });
        };

        /**
		 * @ngdoc method
		 * @name avanzaStep
		 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
		 * @description Esegue la chiamata per far avanzare allo step successivo
	     * @param {string} stepString - stringa che indica a quale step avanzare
		 * @return {Promise} - Restituisce una promise contenente la pratica aggiornata
		 */
        //per muoversi dentro i micro step si passa come stepString rispettivamente /avantiStep e /indietroStep
        this.promiseCambiaStep = function(stepString) {
          return this.$http({
            method: 'PUT',
            url:
              CONSTANTS.REST_ROOT +
              CONSTANTS.REST.PRATICHE.DETTAGLIO +
              this.datiPratica.idPratica +
              stepString
          });
        };

        /**
		 * @ngdoc method
		 * @name promiseConvenzioni
		 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
		 * @description Effettua una chiamata http per recuperare le convenzioni
		 * @return {Promise} - Ritorna una promise contenente le convenzioni
		 */
        this.promiseConvenzioni = function() {
          return this.$http({
            method: 'GET',
            url:
              CONSTANTS.REST_ROOT +
              CONSTANTS.REST.CONVENZIONI +
              '/' +
              this.datiPratica.idPratica
          });
        };

        /**
		 * @ngdoc method
		 * @name promiseSalvataggioIban
		 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
		 * @description Effettua una chiamata http per eseguire il salvataggio del codice IBAN per la pratica
		 * @return {Promise} - Ritorna una promise contenente l'oggetto contoAppoggio da aggiungere nella pratica
		 */
        this.promiseSalvataggioIban = function(iban) {
          this.spinner.conto = true;
          return this.$http({
            method: 'GET',
            url: CONSTANTS.REST_ROOT + CONSTANTS.REST.DETTAGLIO_CONTO,
            params: {codiceIban: iban}
          });
        };

        /**
		 * @ngdoc method
		 * @name promiseSalvaConvenzione
		 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
		 * @description Effettua una chiamata http per eseguire il salvataggio della convenzione selezionata
		 * @return {Promise} - Ritorna una promise contenente la pratica aggiornata
		 */
        this.promiseSalvaConvenzione = function() {
          return this.$http({
            method: 'PUT',
            url:
              CONSTANTS.REST_ROOT +
              CONSTANTS.REST.PRATICHE.DETTAGLIO +
              this.datiPratica.idPratica +
              '/convenzione',
            data: this.convenzione
          });
        };
        
        /**
		 * @ngdoc method
		 * @name promiseSalvaPolizze
		 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
		 * @description Effettua una chiamata http per eseguire il salvataggio delle polizze assegnate alla pratica
		 * @return {Promise} - Ritorna una promise contenente il finanziamento aggiornato
		 */
        this.promiseSalvaPolizze = function() {
        	
          return this.$http({
            method: 'PUT',
            url:
              CONSTANTS.REST_ROOT +
              CONSTANTS.REST.FINANZIAMENTI + '/' +
              this.finanziamento.idFinanziamentoPMI,
            data: this.finanziamento
          });
        };
        
               
        /**
		 * @ngdoc method
		 * @name promiseCompletaFinanziamento
		 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
		 * @description Effettua una chiamata http per eseguire il completamento del finanziamento
		 * @return {Promise} - Ritorna una promise contenente il finanziamento aggiornato
		 */
        this.promiseCompletaFinanziamento = function(fase) {
          return this.$http({
            method: 'PUT',
            url:
              CONSTANTS.REST_ROOT +
              CONSTANTS.REST.PRATICHE.DETTAGLIO +
              this.datiPratica.idPratica + 
              '/completaFinanziamento/fase'+fase+'/',
            data: this.finanziamento
          });
        };
        
              
        /**
		 * @ngdoc method
		 * @name promiseCheckDocumenti
		 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
		 * @description Effettua una chiamata http per verificare che i documenti della pratica siano tutti validi
		 * @param {number} idPratica - l'ID della pratica da verificare
		 * @param {number} idFinanziamento - Opzionale, l'ID del finanziamento da verificare
		 * @return {Promise} - Ritorna una promise contenente l'esito della validazione (true/false)
		 */
        this.promiseCheckDocumenti = function(idPratica, idFinanziamento) {
        	var qryParams = {
          		  idPratica: idPratica
            };
            
            if (idFinanziamento) {
          	  qryParams['idFinanziamento'] = idFinanziamento;
            }
          	
            return this.$http({
              method: 'GET',
              url:
                CONSTANTS.REST_ROOT +
                CONSTANTS.REST.PRATICHE.DETTAGLIO +
                'checkDocumenti',
              params: qryParams
            });
        };
        
        /**
		 * @ngdoc method
		 * @name promiseCheckDocumenti
		 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
		 * @description Effettua una chiamata http per verificare che i documenti della pratica siano tutti validi
		 * @param {number} idPratica - l'ID della pratica da verificare
		 * @param {number} idFinanziamento - Opzionale, l'ID del finanziamento da verificare
		 * @return {Promise} - Ritorna una promise contenente l'esito della validazione (true/false)
		 */
        this.promiseCheckPratichePropedeutiche = function(idPratica) {
        	var qryParams = {
          		  idPratica: idPratica
            };
            
            return this.$http({
              method: 'GET',
              url:
                CONSTANTS.REST_ROOT +
                CONSTANTS.REST.PRATICHE.DETTAGLIO +
                'checkPratichePropedeutiche',
              params: qryParams
            });
        };
        
        /**
		 * @ngdoc method
		 * @name promiseFirmaDocumenti
		 * @methodOf cbl.insuranceloanpmi.mf.directive:CreasDettaglioPraticaSrvc
		 * @description Effettua una chiamata http per firmare i documenti della pratica indicata
		 * @param {number} idPratica - l'ID della pratica per la quale firmare i documenti
		 * @param {number} idFinanziamento - Opzionale, l'ID del finanziamento per il quale firmare i documenti
		 * @return {Promise} - Ritorna una promise contenente l'esito della validazione (true/false)
		 */
        this.promiseFirmaDocumenti = function(idPratica, idFinanziamento) {
        	var qryParams = {
          		  idPratica: idPratica
            };
            
            if (idFinanziamento) {
          	  qryParams['idFinanziamento'] = idFinanziamento;
            }
          	
            return this.$http({
              method: 'GET',
              url:
                CONSTANTS.REST_ROOT +
                CONSTANTS.REST.PRATICHE.DETTAGLIO +
                'firmaDocumenti',
              params: qryParams
            });
        };
        
        
        /**
    	 * @ngdoc method
    	 * @name promiseDatiClienteIntegrazione
    	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasAffidamentoDocumenti
    	 * @description Effettua una chiamata http per recuperare i dati del cliente
    	 *              e dei firmatari
    	 * @return {Promise} - Ritorna una promise contenente i dati del cliente e
    	 *         dei firmatari
    	 */
        this.promiseDatiClienteIntegrazione = function() {
          var queryParamsObj = {
            idPratica: this.datiPratica.idPratica
          };

          return this.$http({
            method: 'GET',
            url:
              CONSTANTS.REST_ROOT + CONSTANTS.REST.CLIENTI.DETTAGLIO_INTEGRAZIONE,
              params: queryParamsObj
          });
        };
        
        /**
    	 * @ngdoc method
    	 * @name promiseAccettaPersonaFisica
    	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasAffidamentoDocumenti
    	 * @description Effettua una chiamata http che conferma la trasformazione da prospetto a cliente della persona fisica
    	 * @return {Promise} - Ritorna una promise per eseguire la conferma della persona fisica
    	 */
    	this.promiseAccettaPersonaFisica = function(idPraticaAnagrafica) {
    		var dataObj = {
    			idPratica: idPraticaAnagrafica,
    			nota: ''
    		};
    		
    		return this.$http({
    			method: 'POST',
    			url: CONSTANTS.REST_CLIENTI_ROOT + CONSTANTS.REST.PERSONAFISICA.ACCETTASENZAWCL,
    			data: dataObj
    		});
    	}
    	
    	/**
    	 * @ngdoc method
    	 * @name promiseAccettaPersonaGiuridica
    	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasAffidamentoDocumenti
    	 * @description Effettua una chiamata http che conferma la trasformazione da prospetto a cliente della persona giuridica
    	 * @return {Promise} - Ritorna una promise per eseguire la conferma della persona giuridica
    	 */
    	this.promiseAccettaPersonaGiuridica = function(idPraticaAnagrafica, formaCostitutiva) {
    		var dataObj = {
    			idPratica: idPraticaAnagrafica,
    			nota: ''
    		};
    		
    		switch(formaCostitutiva) {
    			case "IND":
    				return this.$http({
    					method: 'POST',
    					url: CONSTANTS.REST_CLIENTI_ROOT + CONSTANTS.REST.PERSONAFISICA.ACCETTASENZAWCL,
    					data: dataObj
    				});
    			default:
    				return this.$http({
    					method: 'POST',
    					url: CONSTANTS.REST_CLIENTI_ROOT + CONSTANTS.REST.PERSONAGIURIDICA.ACCETTASENZAWCL,
    					data: dataObj
    				});				
    		}
    	}
      }
    ]);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/creasDettaglioPratica/creasDettaglioPraticaSrvc.js
// module id = 39
// module chunks = 0 1